import React, { useState, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { useSelector } from 'react-redux';
import { PortfolioServiceApi, Configuration } from "../../../services/portfolio";
import { APIControl } from '../../../helpers/APIControl';
import { Toast } from 'primereact/toast';

const CreatePortfolioModal = ({ show, onClose, onPortfolioCreated }) => {
    const [portfolioName, setPortfolioName] = useState('');
    const token = useSelector((state) => state.auth?.token);
    const toast = useRef(null);

    const portfolioServiceApi = new PortfolioServiceApi(
        new Configuration({ basePath: process.env.REACT_APP_PORTFOLIO_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_PORTFOLIO_API_BASE_PATH)
    );

    const handlePortfolioNameChange = (e) => {
        const value = e.target.value;
        if (value.length <= 24) {
            setPortfolioName(value);
        }
    };

    const createPortfolio = async () => {
        try {
            // Validate portfolio name is not empty
            if (!portfolioName.trim()) {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Hata', 
                    detail: 'Portföy adı boş olamaz', 
                    life: 3000 
                });
                return;
            }

            let requestBody = { name: portfolioName }; // Use the actual portfolio name
            const response = await portfolioServiceApi.v1PortfolioCreatePost(token, requestBody);
            
            if (response.data) {
                toast.current.show({ 
                    severity: 'success', 
                    summary: 'Başarılı', 
                    detail: 'Portföy başarıyla oluşturuldu', 
                    life: 3000 
                });
                onPortfolioCreated(true);
                setPortfolioName('');
                onClose();
            } else {
                console.error(response);
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Hata', 
                    detail: 'Portföy oluşturulurken bir hata oluştu', 
                    life: 3000 
                });
                onPortfolioCreated(false);
            }
        } catch (error) {
            console.error(error);
            // Handle specific error for empty name
            if (error.response?.data?.code === 3 && error.response?.data?.message === "Name cannot be empty") {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Hata', 
                    detail: 'Portföy adı boş olamaz', 
                    life: 3000 
                });
            } else {
                const errorMessage = error.response?.data?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Bir hata oluştu', 
                    detail: errorMessage, 
                    life: 3000 
                });
            }
            onPortfolioCreated(false);
        }
    };

    return (
        <>
            <Toast ref={toast} position="bottom-right" />

            <Modal show={show} onHide={onClose} centered className='create-portfolio-modal'>
                <Modal.Header>
                    <Modal.Title className='modalTitle'>Portföy Oluştur</Modal.Title>
                    <FontAwesomeIcon
                        icon={faCircleXmark}
                        onClick={onClose}
                        className="custom-close-icon"
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="portfolioName">
                        <Form.Label className='portfolioInputLabel'>Portföy Adı</Form.Label>
                        <Form.Control
                            className='portfolioInput'
                            type="text"
                            placeholder="Portföyünüze isim verin"
                            value={portfolioName}
                            onChange={handlePortfolioNameChange}
                        />
                        <Form.Text className="text-muted count">
                            {portfolioName.length}/24 Karakterler
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="success"
                        onClick={createPortfolio}
                        className='custom-button button'
                        disabled={portfolioName.length === 0} // Buton sadece isim girildiğinde aktif olacak
                    >
                        Portföy Oluştur
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CreatePortfolioModal;
